import { Chip } from '@material-ui/core';

import {
  RiCloseLine as CloseIcon,
  RiBookmarkFill,
  RiBookmarkLine,
} from '@remixicon/react';

import { ButtonIcon } from '@spotify-internal/encore-web';
import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';
import { createFilter, useFilters } from '@spotify/confidence-core-react';

export const FAVORITES_FILTER = createFilter<boolean>({
  id: 'favorites',
  label: 'Favorites',
  query: () => '',
  editor: ({ onClose }) => {
    onClose();
    return null;
  },
  viewer: ({ onRemove }) => (
    <Chip label="Favorites" onDelete={onRemove} deleteIcon={<CloseIcon />} />
  ),
});

export const useFavoritesFilterToggle = () => {
  const { activeFilters, addFilter, removeFilter } = useFilters();
  const isActive = activeFilters.some(f => f.id === FAVORITES_FILTER.id);
  const toggle = () => {
    if (isActive) {
      removeFilter(FAVORITES_FILTER.id);
    } else {
      addFilter(FAVORITES_FILTER, true);
    }
  };

  return { isActive, toggle };
};

export const FavoritesFilterToggle = () => {
  const { isActive, toggle } = useFavoritesFilterToggle();

  const Icon = isActive ? RiBookmarkFill : RiBookmarkLine;

  return (
    <TooltipRoot>
      <ButtonIcon
        type="button"
        variant={isActive ? 'secondary' : 'tertiary'}
        size="small"
        onClick={toggle}
        aria-label="Filter favourites"
        aria-pressed={isActive}
       data-track-source-anchor="e70115adda;;low">
        <Icon size={16} aria-hidden />
      </ButtonIcon>
      <Tooltip>
        {isActive ? 'Show all resources' : 'Show favorite resources'}
      </Tooltip>
    </TooltipRoot>
  );
};
